import React from "react";
import { Handle, Position } from "@xyflow/react";
import { FaComments } from "react-icons/fa";

export default function AIConversationNode({ data, selected }) {
  return (
    <div
      className={`rounded-xl border-2 bg-surface-card shadow-sm min-w-[180px] transition-shadow ${
        selected ? "border-violet-500 shadow-md" : "border-surface-border"
      }`}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        className="!w-3 !h-3 !bg-violet-500 !border-2 !border-white"
      />

      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 rounded-t-[10px] bg-gradient-to-r from-violet-600 to-purple-500">
        <FaComments size={11} className="text-white" />
        <span className="text-xs font-semibold text-white">AI Conversation</span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5 space-y-1.5">
        {data.prompt ? (
          <p className="text-xs text-ink-muted line-clamp-2">{data.prompt}</p>
        ) : (
          <p className="text-xs text-ink-muted italic">Click to configure AI conversation</p>
        )}
        <div className="flex items-center gap-1.5 flex-wrap">
          {data.exitKeyword && (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-violet-100 text-violet-700 text-2xs font-medium">
              Exit: {data.exitKeyword}
            </span>
          )}
          {data.maxTurns != null && (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-purple-100 text-purple-700 text-2xs font-medium">
              {data.maxTurns === 0 ? "Unlimited" : `${data.maxTurns} turns`}
            </span>
          )}
        </div>
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        className="!w-3 !h-3 !bg-violet-500 !border-2 !border-white"
      />
    </div>
  );
}
